import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface FacilityVideoDialogProps {
  videoUrl: string;
  facilityName: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const FacilityVideoDialog = ({
  videoUrl,
  facilityName,
  open,
  onOpenChange,
}: FacilityVideoDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl p-0 overflow-hidden">
        <DialogHeader className="p-4 pb-0">
          <DialogTitle>{facilityName} - Video</DialogTitle>
        </DialogHeader>
        <div className="aspect-video w-full">
          <video
            src={videoUrl}
            controls
            autoPlay
            className="w-full h-full object-contain bg-black"
          >
            Your browser does not support the video tag.
          </video>
        </div>
      </DialogContent>
    </Dialog>
  );
};
